var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSKey(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 63,
    viewBox: "0 0 68 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_203_249)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.79999,
    y: 6.7998,
    width: 54,
    height: 49,
    rx: 5.5,
    stroke: "#78C7FF",
    strokeWidth: 3,
    shapeRendering: "crispEdges"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.0525 45.8598C31.9458 45.8598 30.0792 45.4865 28.4525 44.7398C26.8258 43.9931 25.5458 42.8998 24.6125 41.4598C23.7058 39.9931 23.2525 38.2198 23.2525 36.1398V35.1398H27.5325V36.1398C27.5325 38.1131 28.1192 39.5931 29.2925 40.5798C30.4925 41.5665 32.0792 42.0598 34.0525 42.0598C36.0525 42.0598 37.5592 41.6465 38.5725 40.8198C39.5858 39.9665 40.0925 38.8731 40.0925 37.5398C40.0925 36.6598 39.8525 35.9398 39.3725 35.3798C38.8925 34.8198 38.2125 34.3798 37.3325 34.0598C36.4525 33.7131 35.3992 33.3931 34.1725 33.0998L32.6925 32.7398C30.9058 32.3131 29.3458 31.7931 28.0125 31.1798C26.7058 30.5398 25.6925 29.6998 24.9725 28.6598C24.2525 27.6198 23.8925 26.2865 23.8925 24.6598C23.8925 23.0065 24.2925 21.5931 25.0925 20.4198C25.9192 19.2465 27.0525 18.3398 28.4925 17.6998C29.9325 17.0598 31.6258 16.7398 33.5725 16.7398C35.5192 16.7398 37.2525 17.0731 38.7725 17.7398C40.3192 18.4065 41.5325 19.3931 42.4125 20.6998C43.2925 22.0065 43.7325 23.6465 43.7325 25.6198V27.0598H39.4525V25.6198C39.4525 24.4198 39.1992 23.4465 38.6925 22.6998C38.2125 21.9531 37.5325 21.4065 36.6525 21.0598C35.7725 20.7131 34.7458 20.5398 33.5725 20.5398C31.8658 20.5398 30.5325 20.8998 29.5725 21.6198C28.6392 22.3131 28.1725 23.2865 28.1725 24.5398C28.1725 25.3931 28.3725 26.0998 28.7725 26.6598C29.1992 27.1931 29.8125 27.6331 30.6125 27.9798C31.4125 28.3265 32.4125 28.6331 33.6125 28.8998L35.0925 29.2598C36.9058 29.6598 38.5058 30.1798 39.8925 30.8198C41.2792 31.4331 42.3725 32.2731 43.1725 33.3398C43.9725 34.4065 44.3725 35.7798 44.3725 37.4598C44.3725 39.1398 43.9458 40.6065 43.0925 41.8598C42.2658 43.1131 41.0792 44.0998 39.5325 44.8198C37.9858 45.5131 36.1592 45.8598 34.0525 45.8598Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_203_249",
    x: -0.0000123978,
    y: -0.000195503,
    width: 67.6,
    height: 62.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.65
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.470588 0 0 0 0 0.780392 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_203_249"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_203_249",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSKey);
export default __webpack_public_path__ + "static/media/SKey.0cf17d74ba4bbd0e6900df9cbb1dd765.svg";
export { ForwardRef as ReactComponent };